// filepath: c:\Users\Gigabyte\Documents\Construcción y evolucion del software\Proyecto avarcibe\Evaluacion_riesgos\Cliente\src\services\empresas\empresasData.js
import axiosInstance from '../../config/axiosConfig';
import { urlEmpresas } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Obtener todas las empresas
export const getEmpresasRequest = async () => {
  const response = await axiosInstance.get(urlEmpresas);
  return extractArray(response);
};

// Crear empresa
export const createEmpresaRequest = async (empresa) => {
  const response = await axiosInstance.post(urlEmpresas, empresa);
  return extractDataObject(response);
};

// Actualizar empresa
export const updateEmpresaRequest = async (id, empresa) => {
  const response = await axiosInstance.put(`${urlEmpresas}/${id}`, empresa);
  return extractDataObject(response);
};

// Eliminar empresa
export const deleteEmpresaRequest = async (id) => {
  const response = await axiosInstance.delete(`${urlEmpresas}/${id}`);
  return extractDataObject(response);
};

// Habilitar empresa
export const enableEmpresa = async (id) => {
  const response = await axiosInstance.put(`${urlEmpresas}/${id}/habilitar`);
  return extractDataObject(response);
};

// Deshabilitar empresa
export const disableEmpresa = async (id) => {
  const response = await axiosInstance.put(`${urlEmpresas}/${id}/deshabilitar`);
  return extractDataObject(response);
};

// Obtener logo de empresa por ID de usuario
export const getLogoEmpresaByUserId = async (idUsuario) => {
  try {
    const response = await axiosInstance.get(`${urlEmpresas}/logo/usuario/${idUsuario}`, {
      // Configuración para silenciar el error 404 en consola
      validateStatus: (status) => status < 500, // No lanzar error para 404
    });
    
    // Si la respuesta es 404, retornar null sin error
    if (response.status === 404) {
      return null;
    }
    
    const data = extractDataObject(response);
    return data?.emp_logo || null;
  } catch (error) {
    // Si el error tiene status 404 o es silencioso, retornar null
    if (error?.status === 404 || error?.silent) {
      return null;
    }
    if (error?.response?.status === 404) {
      return null;
    }
    // Solo lanzar errores que no sean 404
    throw error;
  }
};